import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Emoji as Emoji$1 } from '../../primitives/internal/Emoji.js';
import { classNames } from '../../utils/class-names.js';

const Emoji = forwardRef(
  ({ className, ...props }, forwardedRef) => {
    return /* @__PURE__ */ jsx(Emoji$1, {
      className: classNames("lb-emoji", className),
      ...props,
      ref: forwardedRef
    });
  }
);

export { Emoji };
//# sourceMappingURL=Emoji.js.map
